import { useState } from 'react';
import {
  StyledAddButton,
  StyledAddButtonWrapper,
  StyledFieldInputWrapper,
} from '../styles';
import { getAddButtonText, getAddValuesPlaceholder } from '../helpers';
import { useTranslation } from 'react-i18next';
import FieldInput from 'components/Fields/FieldInput';
import { UnstyledTextEllipseWithTooltip } from '__components/UnstyledTextEllipseWithTooltip';

export const AddValuesButton = ({
  field,
  access,
  entityId,
  addValues,
  onAddValues,
  isMobile,
  setConflicts,
  checkConflictingPrimaryRelationship = false,
}) => {
  const { t } = useTranslation();
  const [openAddValue, setOpenAddValue] = useState(false);
  return (
    <StyledAddButtonWrapper>
      <StyledAddButton
        variant="text"
        onClick={() => {
          setOpenAddValue(true);
        }}
      >
        <UnstyledTextEllipseWithTooltip>
          {getAddButtonText(field, isMobile, t)}
        </UnstyledTextEllipseWithTooltip>
      </StyledAddButton>
      {openAddValue ? (
        <StyledFieldInputWrapper>
          <FieldInput
            sizing={isMobile ? 'mobile' : 'auto'}
            field={field}
            access={access}
            entityId={entityId}
            label={false}
            inModal
            menuIsOpen
            alwaysOpen
            autoFocus
            onChange={(v) => onAddValues(v)}
            value={addValues}
            handleClickApply={() => setOpenAddValue(false)}
            hideAddButton
            placeholder={getAddValuesPlaceholder(field, t)}
            excludeExistingValues
            shouldRefetchOnMount
            setConflicts={setConflicts}
            checkConflictingPrimaryRelationship={
              checkConflictingPrimaryRelationship
            }
          />
        </StyledFieldInputWrapper>
      ) : null}
    </StyledAddButtonWrapper>
  );
};
